import { render } from "./ListGames.vue?vue&type=template&id=1a533ff6"
import script from "./ListGames.vue?vue&type=script&lang=js"
export * from "./ListGames.vue?vue&type=script&lang=js"

import "./ListGames.vue?vue&type=style&index=0&id=1a533ff6&lang=scss"

import exportComponent from "/root/tools-store-ranking-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__